import { ServiceCustomer } from '@/service/customer/serviceCustomer'

const serviceCustomer = new ServiceCustomer()
export default {
  namespaced: true,
  state: {
    loadingContacts: false,
    contacts: [],
  },
  getters: {
    contacts: state => state.contacts,
    loadingContacts: state => state.loadingContacts,
    totalUnreadMessages: state => {
      if (!Array.isArray(state.contacts)) return 0

      return state.contacts.reduce((total, contact) => total + (contact.unreadMessages || 0), 0)
    },
  },
  mutations: {
    SET_LOADING_CONTACTS(state, loading) {
      state.loadingContacts = loading
    },
    SET_CONTACTS(state, contacts) {
      state.contacts = contacts
    },
    UPDATE_UNREAD_MESSAGES(state, { chatId, count }) {
      const contactIndex = state.contacts.findIndex(c => c.chatId === chatId)
      if (contactIndex >= 0) {
        state.contacts[contactIndex].unreadMessages = count
      }
    },
    INCREMENT_UNREAD_MESSAGES(state, { chatId }) {
      const contactIndex = state.contacts.findIndex(c => c.chatId === chatId)
      if (contactIndex >= 0) {
        const currentCount = state.contacts[contactIndex].unreadMessages || 0
        state.contacts[contactIndex].unreadMessages = currentCount + 1
      }
    },
    UPDATE_LAST_MESSAGE(state, { chatId, message, date }) {
      const contactIndex = state.contacts.findIndex(c => c.chatId === chatId)
      if (contactIndex >= 0) {
        state.contacts[contactIndex].lastMessage = message
        state.contacts[contactIndex].date = date || new Date().toLocaleDateString('pt-BR')

        const updatedContact = state.contacts.splice(contactIndex, 1)[0]
        state.contacts.unshift(updatedContact)
      }
    },
  },
  actions: {
    async fetchChatsAndContacts({ commit }, query) {
      commit('SET_LOADING_CONTACTS', true)
      try {
        const response = await serviceCustomer.contacts(query)
        if (response && response.contacts) {
          commit('SET_CONTACTS', response.contacts)
        }
        return response
      } catch (error) {
        // (error)
        return { contacts: [] }
      } finally {
        commit('SET_LOADING_CONTACTS', false)
      }
    },

    async getChatMessages({ commit }, chatId) {
      try {
        const response = await serviceCustomer.getChatMessages(chatId)
        return response
      } catch (error) {
        // console.log(error)
        return { error: true, message: 'Não foi possível carregar as mensagens' }
      }
    },

    async markMessagesAsRead({ commit }, { chatId, userId }) {
      try {
        const response = await serviceCustomer.markMessagesAsRead(chatId, userId)
        commit('UPDATE_UNREAD_MESSAGES', { chatId, count: 0 })
        return response
      } catch (error) {
        console.log(error)
      }
    },

    sendMessage({ commit }, { chatId, message }) {
      return new Promise((resolve, reject) => {
        serviceCustomer.sendMessage(chatId, { message })
          .then(response => {
            commit('UPDATE_LAST_MESSAGE', {
              chatId,
              message,
              date: new Date().toLocaleDateString('pt-BR'),
            })
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },

    handleFileUpload({ commit }, { chatId, formData }) {
      return new Promise((resolve, reject) => {
        serviceCustomer.handleFileUpload(chatId, formData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    addNewContact({ commit, state }, contactData) {
      const contacts = [...state.contacts]
      const existingIndex = contacts.findIndex(c => c.chatId === contactData.chatId)

      if (existingIndex >= 0) {
        contacts[existingIndex] = { ...contacts[existingIndex], ...contactData }
      } else {
        contacts.push(contactData)
      }

      commit('SET_CONTACTS', contacts)
    },

    updateUnreadCount({ commit }, { chatId, count }) {
      commit('UPDATE_UNREAD_MESSAGES', { chatId, count })
    },

    incrementUnreadCount({ commit }, { chatId }) {
      commit('INCREMENT_UNREAD_MESSAGES', { chatId })
    },

    updateLastMessage({ commit }, { chatId, message, date }) {
      commit('UPDATE_LAST_MESSAGE', { chatId, message, date })
    },

    processNewMessage({ commit, state }, messageData) {
      if (!messageData || !messageData.chatId) return

      const userData = JSON.parse(localStorage.getItem('userData'))
      const customerId = userData?.customerId

      if (messageData.senderId !== customerId) {
        commit('INCREMENT_UNREAD_MESSAGES', { chatId: messageData.chatId })
      }

      commit('UPDATE_LAST_MESSAGE', {
        chatId: messageData.chatId,
        message: messageData.message,
        date: new Date().toLocaleDateString('pt-BR'),
      })
    },
  },
}
